import React, { useState, useEffect } from 'react';
import '../styles/ComicLoading.css';
import SYMBOLS from '../utils/symbols';

const ComicLoading = () => {
  const [loadingText, setLoadingText] = useState("CONNECTING TO DOC");
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const messages = [
      "CONNECTING TO DOC",
      "DOC IS SCANNING TIMELINES",
      "DOC IS LOCATING YOUR MISSION",
      "ESTABLISHING SECURE CHANNEL",
      "DOC IS PREPARING YOUR BRIEFING",
      "STAND BY FOR MISSION DETAILS"
    ];

    let messageIndex = 0;
    const messageInterval = setInterval(() => {
      messageIndex = (messageIndex + 1) % messages.length;
      setLoadingText(messages[messageIndex]);
    }, 1800);

    const dotInterval = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4);
    }, 400);

    return () => {
      clearInterval(messageInterval);
      clearInterval(dotInterval);
    };
  }, []);

  const dots = '.'.repeat(dotCount);

  return (
    <div className="comic-loading">
      {/* Animated background */}
      <div className="loading-background">
        <div className="ink-splatter splatter-1"></div>
        <div className="ink-splatter splatter-2"></div>
        <div className="ink-splatter splatter-3"></div>
        
        <div className="speed-lines">
          {[...Array(12)].map((_, i) => (
            <div key={i} className={`speed-line line-${i}`}></div>
          ))}
        </div>
      </div>

      {/* Main content */}
      <div className="loading-content">
        {/* Animated comic book icon */}
        <div className="book-animation">
          <div className="book">
            <div className="book-cover">
              <div className="cover-title">RIBBON RIDER</div>
              <div className="cover-subtitle">COMICS</div>
            </div>
            <div className="book-pages">
              <div className="page page-1"></div>
              <div className="page page-2"></div>
              <div className="page page-3"></div>
            </div>
          </div>
        </div>

        {/* Loading text */}
        <div className="loading-text-container">
          <h2 className="loading-title">
            {loadingText}<span className="loading-dots">{dots}</span>
          </h2>
          <p className="loading-subtitle">Doc will be with you shortly, Agent...</p>
        </div>

        {/* Progress bar */}
        <div className="progress-container">
          <div className="progress-track">
            <div className="progress-fill"></div>
            <div className="progress-glow"></div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="corner-decoration top-left">{SYMBOLS.CORNER_TL}</div>
        <div className="corner-decoration top-right">{SYMBOLS.CORNER_TR}</div>
        <div className="corner-decoration bottom-left">{SYMBOLS.CORNER_BL}</div>
        <div className="corner-decoration bottom-right">{SYMBOLS.CORNER_BR}</div>
      </div>
    </div>
  );
};

export default ComicLoading;